var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner unlock-apply-dialog",
          attrs: {
            visible: _vm.innerVisible,
            width: "640px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "header-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "line-height": "24px",
                    "font-size": "18px",
                    color: "#333333"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.UnlockApplyTitle")))]
              )
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.submitting,
                  expression: "submitting"
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "margin-bottom": "10px", "font-size": "14px" }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("SeaExport.UnlockApplyJobCount", [
                          _vm.selectedJobs.length
                        ])
                      ) +
                      " "
                  ),
                  _c("span", { staticStyle: { color: "#909399" } }, [
                    _vm._v(
                      "（" +
                        _vm._s(_vm.$t("SeaExport.UnlockApplyCountLimitTip")) +
                        "）"
                    )
                  ])
                ]
              ),
              _c(
                "el-table",
                {
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: {
                    data: _vm.selectedJobs,
                    border: "",
                    size: "mini",
                    "max-height": "200"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("SeaExport.BusinessNo"),
                      prop: "jobNo",
                      "min-width": "140",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("SeaExport.ConsignationCompany"),
                      "min-width": "180",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_vm._v(_vm._s(_vm.customerName(scope.row)))]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "unlockApplyForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "130px",
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.UnlockApplyReason"),
                        prop: "reason"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          maxlength: "500",
                          "show-word-limit": "",
                          placeholder: _vm.$t(
                            "SeaExport.UnlockApplyReasonPlaceholder"
                          )
                        },
                        model: {
                          value: _vm.form.reason,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "reason", $$v)
                          },
                          expression: "form.reason"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.DeclaredProfitImpact"),
                        prop: "declaredProfitImpact"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { precision: 2, controls: false },
                        model: {
                          value: _vm.form.declaredProfitImpact,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "declaredProfitImpact", $$v)
                          },
                          expression: "form.declaredProfitImpact"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.failures.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-bottom": "5px",
                            color: "#F56C6C",
                            "font-size": "14px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.UnlockApplyPrecheckFailed")
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.failures,
                            border: "",
                            size: "mini",
                            "max-height": "200"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("SeaExport.BusinessNo"),
                              prop: "jobNo",
                              "min-width": "140",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "SeaExport.UnlockApplyFailureReason"
                              ),
                              prop: "reason",
                              "min-width": "220",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.submitting },
                  on: { click: _vm.toSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.UnlockApplySubmit")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }